import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  coordinateSystemsAdapter,
  coordinateSystemsKey,
  ICoordinateSystemsState,
  initialState,
} from './coordinate-systems.state';

export const selectCoordinateSystemsState = createSelector(
  createFeatureSelector<ICoordinateSystemsState | undefined>(coordinateSystemsKey),
  (state): ICoordinateSystemsState => state ?? initialState
);

const { selectAll, selectEntities } = coordinateSystemsAdapter.getSelectors(selectCoordinateSystemsState);

export const selectAllCoordinateSystems = selectAll;
export const selectCoordinateSystemEntities = selectEntities;

export const selectCoordinateSystemsLoading = createSelector(selectCoordinateSystemsState, state => state.loading);
export const selectCoordinateSystemsLoaded = createSelector(selectCoordinateSystemsState, state => state.loaded);
export const selectCoordinateSystemsError = createSelector(selectCoordinateSystemsState, state => state.error);
